import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import React from 'react';

import { useTranslator } from '@/hooks/useTranslator';

interface Props {
  readonly title?: string;
}

export const DetailsValue: React.FC<React.PropsWithChildren<Props>> = (
  props: React.PropsWithChildren<Props>,
): React.ReactElement => {
  const { children: value, title } = props;
  const tr = useTranslator();

  const Wrapper = React.useCallback(
    function Wrapper(props: React.PropsWithChildren): React.ReactNode {
      const { children } = props;
      if (title) {
        // TODO: copy on click
        return (
          <Tooltip title={tr(title)}>
            <>{children}</>
          </Tooltip>
        );
      } else {
        return children;
      }
    },
    [title, tr],
  );

  if (typeof value === 'string') {
    return (
      <Wrapper>
        <Typography variant="body2" color="text.primary">
          {tr(value)}
        </Typography>
      </Wrapper>
    );
  } else if (React.isValidElement(value)) {
    return <Wrapper>{value}</Wrapper>;
  } else {
    return <></>;
  }
};
